import { Image } from "@/components/Elements";
import { RouteConstant } from "@/routes/routeConstant";
import { selectRecipient } from "@/store/chat";
import { RecipientModel } from "@/types/chat";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const Recipient = ({ recipient }: { recipient: RecipientModel }) => {
  const {
    fullName,
    userImageUrl,
    lastMessage,
    lastMessageSentOn,
    unReadCount,
  } = recipient;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const openMessage = () => {
    dispatch(selectRecipient(recipient));
    navigate(RouteConstant.Message);
  };

  return (
    <div className="mb-[15px] h-[50px] border-b-[#d3d3d3]">
      <div className="flex">
        <Image
          src={userImageUrl}
          isApiUrl
          className="w-[50px] h-[50px] rounded-[50px] border border-[#d3d3d3]"
        />
        <div className="flex-1 ml-[7px]" onClick={openMessage}>
          <div className="flex justify-between">
            <div className="text-[16px] font-extrabold">{fullName}</div>
            <div className="text-[11px] text-[#898989]">
              {lastMessageSentOn}
            </div>
          </div>
          <div className="row justify-between">
            <div
              className={`text-[11px] ${
                unReadCount > 0 ? "#646464" : "#bfbfbf"
              }`}
            >
              {lastMessage}
            </div>
            {unReadCount > 0 && (
              <div className="w-[24px] h-[24px] bg-[#e8434d] rounded-[7px] items-center justify-center">
                <div className="text-[11px] text-[#fff]">{unReadCount} </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Recipient;
